import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router';

import { Helmet } from 'react-helmet';
import HomePage from '../views/HomePage';
import ContentPage from '../views/ContentPage';
import useApiUrl from './hooks/useApiUrlHook';
import TeamOverview from "../views/team/TeamOverview";
import NotFoundPage from "../views/NotFoundPage";
import ContactPage from "../views/ContactPage";
import CaseOverview from "../views/case/CaseOverview";
import ServiceOverview from "../views/service/ServiceOverview";

/**
 * Catchall for unmatched routes reroutes to correct view.
 */
export default function ResolvePage({ children }) {
    const { path } = useParams();
    const apiUrl = useApiUrl();

    const location = useLocation();

    const [page, setPage] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    useEffect(() => {
        if (apiUrl === null) return;

        axios
            .post(`${apiUrl}/page`, { path })
            .then((response) => {
                setPage(response.data);
            })
            .catch(() => {
                setPage({ script: '404', titletag: '', titel: 'Pagina niet gevonden' });
            });
    }, [path, apiUrl]);

    if (errorMessage !== null) return <div>Foutmelding page {errorMessage}</div>;

    if (page === null) return <div>Loading </div>;

    let pageElement;

    switch (page.script) {
        case '404':
            pageElement = <NotFoundPage />;
            break;
        case 'home':
            pageElement = <HomePage page={page} />;
            break;
        case 'team':
            pageElement = <TeamOverview page={page} />;
            break;
        case 'project':
            pageElement = <CaseOverview page={page} />;
            break;
        case 'diensten':
            pageElement = <ServiceOverview page={page} />;
            break;
        case 'contact':
            pageElement = <ContactPage page={page} />;
            break;
        default:
            pageElement = <ContentPage page={page} />;
            break;
    }

    return (
        <>
            <Helmet>
                <title>
                    {page.titletag !== '' ? page.titletag : page.titel} - {process.env.MIX_REACT_APP_APP_NAME}
                </title>
                <meta
                    name="name"
                    content={`${page.titletag !== '' ? page.titletag : page.titel} - ${
                        process.env.MIX_REACT_APP_APP_NAME
                    }`}
                />
                {page.image !== null && page.image !== '' ? (
                    <meta name="image" content={`${apiUrl}/img/exactg/website/1920/1080/100/${page.image}`} />
                ) : null}
                <meta name="description" content={page.description} />
                <meta name="keywords" content={page.keywords} />
            </Helmet>
            {pageElement}
        </>
    );
}
